import { InitialData } from "@proj-client/utils/initialData"
import { IUserDataStore } from "@proj-common/types"
import { devtools } from 'zustand/middleware'
import { create } from 'zustand'
import { SiteDeploymentType } from "@proj-common/utils"


const ErrorStoreDefaultData: Partial<IUserDataStore> = {

}

export const useUserDataStore = create<IUserDataStore>()(devtools((set) => ({
    ...ErrorStoreDefaultData,
    ...InitialData.UserDataStore,
    setEmail: (email) => set((state) => ({ email })),
    setMetadata: (metadata) => set((state) => ({ metadata })),
    setUserName: (user_name) => set((state) => ({ user_name })),
    setSessionName: (session_name) => set((state) => ({ session_name })),
    setSubscriptionDetails: (subscriptionDetails) => set((state) => ({ subscriptionDetails }))
}), { name: 'Ideate Live', store: 'UserDataStore', enabled: SiteDeploymentType() == 'development' }))